import { render } from "./ChatMessageManager.vue?vue&type=template&id=47cca584"
import script from "./ChatMessageManager.vue?vue&type=script&lang=js"
export * from "./ChatMessageManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__